import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { isNullOrUndefined } from '../store/storeFunctions';
import Moment from 'moment'
import { CustomSelect } from './common/formFields/customSelect';

import { appContextActions } from '../store/appContextStore';
import { setLanguage, hasPermission, getMomentLanguage } from '../store/apiWrapper';
import FieldHorizontal from './common/formFields/fieldHorizontal';
import Loading from './common/loading/loading';
import InputControl from './common/formFields/inputControl';

class SettingsComponent extends React.Component {
    state = this.getUserData();

    getUserData() {
        var user = this.props.authentication.profile;
        var langCode = this.getLanguage(this.props);
        return { userName: user.username, name: user.name, surName: user.surname, email: user.email, language: langCode, errors: {} };
    }
    UNSAFE_componentWillMount() {
        this.props.resetSettings();
    }

    getLanguage(props) {
        var lang = props.languages.find((element) => {
            return element.code === props.i18n.language;
        });
        var langCode = "";
        if (!isNullOrUndefined(lang)) {
            langCode = lang.code;
        }
        return langCode;
    }

    static getDerivedStateFromProps(props, state) {
        var lang = props.languages.find((element) => {
            return element.code === props.i18n.language;
        });
        if (!isNullOrUndefined(lang) && state.language.length === 0) {
            return { language: lang.code };
        }
        return null;
    }

    changeEvent = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    changeLanguage(lang) {
        Moment.locale(getMomentLanguage(lang) || 'sk');
        this.props.fetchTranslations(lang, true);
        setLanguage(lang)
    }

    handleSaveSubmit = (event) => {
        let errors = {};
        if (hasPermission(null, "UserCCB") || hasPermission(null, "UserRatingMSP") || hasPermission(null, "UserRatingCalc") || hasPermission(null, "PartnerView")) {
            if (isNullOrUndefined(this.state.surName) || this.state.surName.length < 1) {
                errors.surName = this.props.t('Common.RequiredField');
            }
            if (isNullOrUndefined(this.state.name) || this.state.name.length < 1) {
                errors.name = this.props.t('Common.RequiredField');
            }
        }
        if (hasPermission(null, "UserRatingMSP")) {
            if (isNullOrUndefined(this.state.email) || this.state.email.length < 1) {
                errors.email = this.props.t('Common.RequiredField');
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)) {
                errors.email = this.props.t('Common.InvalidEmail');
            }
        }
        this.setState({ errors: errors });
        event.preventDefault();
        if (Object.keys(errors).length === 0) {
            this.props.updateUser(this.props.authentication.profile.id, this.state.email, this.state.name, this.state.surName, this.state.language);
            this.changeLanguage(this.state.language);
        }
    }

    render() {
        return (
            <div className="columns work-container">
                <div className="column left-navbar-container">
                </div>
                <div className="column right-body-container is-three-quarters">
                    <div className="container is-centered columns">
                        <div className="column is-6 form-layout">
                            {this.renderSettings(this.props.settings)}
                        </div>
                    </div>
                </div>
                <div className="column">
                </div>
                {this.renderLoading()}
            </div>
        )
    }

    renderLoading = () => {
        if (this.props.settings.isUpdating)
            return (<Loading />);

    }

    renderSettings() {
        return (

            <div className="box">
                <div className="has-text-centered">
                    <h1 className="title is-4">{this.props.t('IRating.Settings.Title')}</h1>
                </div>
                <form onSubmit={(e) => this.handleSaveSubmit(e)}>
                    <div className="container">
                        <FieldHorizontal label={this.props.t('IRating.Settings.UserName')}>
                            <InputControl type="text" fieldName="userName" disabled={true} value={this.state.userName} placeholder={this.props.t('IRating.Settings.UserName')} onChange={this.changeEvent} />
                        </FieldHorizontal>
                        {(hasPermission(null, "UserCCB") || hasPermission(null, "UserRatingMSP") || hasPermission(null, "UserRatingCalc") || hasPermission(null, "PartnerView")) &&
                            <>
                                <FieldHorizontal label={this.props.t('IRating.Settings.Name')}>
                                    <InputControl type="text" fieldName="name" value={this.state.name} error={this.state.errors.name} placeholder={this.props.t('IRating.Settings.Name')} onChange={this.changeEvent} />
                                </FieldHorizontal>
                                <FieldHorizontal label={this.props.t('IRating.Settings.SurName')}>
                                    <InputControl type="text" fieldName="surName" value={this.state.surName} error={this.state.errors.surName} placeholder={this.props.t('IRating.Settings.SurName')} onChange={this.changeEvent} />
                                </FieldHorizontal>
                            </>
                        }
                        <FieldHorizontal label={this.props.t('IRating.Settings.Email')}>
                            <InputControl type="email" fieldName="email" value={this.state.email} error={this.state.errors.email} placeholder={this.props.t('IRating.Settings.Email')} onChange={this.changeEvent} />
                        </FieldHorizontal>
                        <FieldHorizontal label={this.props.t('IRating.Settings.Language')}>
                            <CustomSelect
                            value={this.state.language}
                            onChange={language => this.setState({ language })}
                            options={this.props.languages.map(x => { return { value: x.code, label: x.name } })}
                            isMulti={false}
                            isLoading={this.props.langLoading} 
                            placeholder={null}
                        />
                        </FieldHorizontal>
                        <div className="field is-horizontal">
                            <div className="field-label">
                            </div>
                            <div className="field-body">
                                <div className="field">
                                    <div className="control">
                                        <button className="button is-primary" type="submit">{this.props.t('IRating.Common.Button.Save')}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}
export default withTranslation("translation")(connect(
    state => state.appContext,
    dispatch => bindActionCreators(appContextActions, dispatch)
)(SettingsComponent));
